<template>
  <!-- 登录 -->
  <div class="page">
    <div style="width: 500px">
      <div class="title">系统登录</div>
      <!-- 登录表单 -->
      <div class="form">
        <el-input
          placeholder="用户名"
          v-model="form.user"
          clearable
          prefix-icon="el-icon-user"
          :disabled="isStore"
          style="margin-top: 24px;"
        >
        </el-input>
        <el-input
          placeholder="密码"
          v-model="form.pwd"
          prefix-icon="el-icon-lock"
          show-password
          class="input"
          :disabled="isStore"
          style="margin-top: 24px;"
        >
        </el-input>
        <div style="margin-top: 24px;display: flex;">
          <el-input
            placeholder="验证码"
            v-model="form.code"
            prefix-icon="el-icon-mobile"
            class="input"
            :disabled="isStore"
            style="flex: 1;margin-right: 10px;"
          >
          </el-input>
          <el-button type="primary" :disabled="isStore || codeLoading || codeTime > 0" :loading="codeLoading" @click="getCode">
          {{ codeTime > 0 ? `${codeTime}秒后再试` : '获取验证码' }}
          </el-button>
        </div>
      </div>
      <el-button
        type="primary"
        style="width: 100%; margin-top: 50px"
        :loading="isStore"
        @click="onLogin"
        >登录</el-button
      >
    </div>
  </div>
</template>

<script>
import secretManager from '@/components/secret/secret.js';
import JSEncrypt from "jsencrypt"
const encryptor = new JSEncrypt();
encryptor.setPublicKey(`MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCRse0t5ARxMcvHw411SUwWJYZfrnR6nDY5x3pCWv/SD57oOxcwQe1k2Ldaa1bnHrQqpGhel5ojOeO/9KkqysHAdIlj/5l9PJHFE6EjZRfyK0UMEEiQuUllpIOAhBwHtRM+j5YRYnOimrsvmN2ZS74CeWnScsG0Ik0MQWT0fnnSnwIDAQAB`)
let codeTimer = null
export default {
  data() {
    return {
      form: {
        user: "",
        pwd: "",
        code: ""
      },
      isStore: false,
      codeTime: 0,
      codeLoading: false
    };
  },
  methods: {
    getCode() {
      if(!/^1[3456789]\d{9}$/.test(this.form.user)){
        this.$message({
          message: "用户名不符合手机号规范",
          type: "error",
        });
        return
      }
      if(!this.form.pwd){
        this.$message({
          message: "密码不能为空",
          type: "error",
        });
        return
      }
      clearInterval(codeTimer)
      this.codeLoading = true;
      this.axios
        .post("/app/note/oauth/sendSms", {
          scene: 8,
          tel: this.form.user,
					...secretManager.getSecretKey(this.form.user, 8)
        }).then(res=>{
          this.codeLoading = false;
          if (res.data.code != 200) {
            this.$message({
              message: res.data.mesg,
              type: "error",
            });
            return
          }
          
					if(!res.data.data){
            this.$message({
              message: "操作过快",
              type: "error",
            });
          return
					}
            this.$message({
              message: "获取验证码成功",
              type: "success",
            });
            this.codeTime = 60;
            codeTimer = setInterval(() => {
              this.codeTime -= 1
              if(this.codeTime<=0){
                clearInterval(codeTimer)

              }
            }, 1000);
        })
        .catch((err) => {
          this.codeLoading = false;
        });
    },
    onLogin() {
      if(!/^1[3456789]\d{9}$/.test(this.form.user)){
        this.$message({
          message: "用户名不符合手机号规范",
          type: "error",
        });
        return
      }
      if(!this.form.pwd){
        this.$message({
          message: "密码不能为空",
          type: "error",
        });
        return
      }
      if(!this.form.code){
        this.$message({
          message: "验证码不能为空",
          type: "error",
        });
        return
      }
      this.isStore = true;
      this.axios
        .get("/admin/login/adminLogin", {
          account: this.form.user,
          pwd:  encryptor.encrypt(this.form.pwd),
          code: this.form.code,
          supers: 1,
        })
        .then((res) => {
          this.isStore = false;
          // 登录成功
          if (res.data.code == 200) {
            // 登录成功
            sessionStorage.setItem("token", res.data.data.token);
            sessionStorage.setItem(
              "admin",
              JSON.stringify(res.data.data.admin)
            );
            sessionStorage.setItem(
              "sidebar",
              JSON.stringify(res.data.data.action)
            );
            this.$message({
              message: "登录成功",
              type: "success",
            });
            clearInterval(codeTimer)
            // 跳转首页
            this.$router.push("/");
            return
          } 
            this.$message({
              message: res.data.mesg,
              type: "error",
            });
          
        })
        .catch((err) => {
          this.isStore = false;
          // this.$message({
          //   message: "登录失败",
          //   type: "error",
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #2d3a4b;
  justify-content: center;
}
.title {
  text-align: center;
  margin-top: 150px;
  color: #eeeeee;
  font-size: 26px;
  font-weight: bold;
}
</style>
